import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importMarketplacePartnerOnboardingSignupContainer = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "MarketplacePartnerOnboardingSignupContainer" */
                '@perpay-web/fintech/components/containers/MarketplacePartnerOnboardingSignupContainer'
            ),
    );
